import { Table } from "react-bootstrap";
import NoDataFound from "../NoDataFound/NoDataFound";
import {redDelete, VectorBell} from "../../assets/assets";

const tableComponent = (props: any) => {  
  console.log(props);
  
  return (
    <div>
      {props.data && props.data?.length > 0 ? (
        <>
          <Table responsive   hover  className="vertical-bordered-table" id="table">
            <thead>
              <tr>
                {props.columns.map((column: any) => (
                  <th className={`${props?.showAction ? 'referral-data' : 'text-center'}`} key={column.dataKey}>{column.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {props.data?.map((row: any, rowIndex: any) => (
                <tr onClick={() => props.callFunction(rowIndex)} key={rowIndex}>
                  {row?.map((cell: any, cellIndex: any) => {
                    
                   return (
                    //  <td id={cell} className={ cell=='Not Registered'?'text-success':'text-center tableindex__' + cellIndex + " " + cell} key={cellIndex}>{cell != null && (cell + '') ? cell : '-'}</td>
                    <td id={cell} className={`table_data tableindex__${cellIndex} ${props?.showAction ? '' : 'text-center'} ${cell} ${cell === 'Registered' ? 'text-success' : ''}`} key={cellIndex}>{cell != null && (cell + '') ? cell : '-'}</td>
                   ) 
                  })}

                {props?.showAction && <td className={'tableindex__'}> {row[4] === 'Not Registered'?<span className="deleteImg"><img onClick={() => props.deleteItem(row)} src={redDelete} alt=""/></span>:''}</td>}
                {props?.showAction && <td className={'tableindex__'}>{row[4] === 'Not Registered'?<button type="button" onClick={() => props.sendReminder(row)} className="sendReminder"><img src={VectorBell} alt="" /><span> Send Reminder</span></button>:''}</td>}
                {props?.showAction && <td className={'tableindex__'}><span className="detailsText"  onClick={() => props.showDetail(row)}>Details</span></td>}
              
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default tableComponent;
